module.exports = __webpack_public_path__ + "static/img/world-class.37f6341.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/how-it-works/world-class.png
// module id = D/zv
// module chunks = 38